<section class="main_section">
  <!-- <div class="top_navbar">
      <app-home-nav-bar></app-home-nav-bar>
  </div> -->
  <div class="body_section">
    <div class="our_icon">
      <img alt="" src="./../../../../assets/images/logo.svg">
    </div>
    <!-- <div class="our_icon" *ngIf="login_type == 'EDUCATION_SYSTEM'">
        <img src="./../../../../assets/images/custom-login/login-image.png" alt="">
    </div> -->
    <div class="section_title">
      Reset Password
    </div>
    <div class="hr-line"></div>
    <div class="field business-field-section">
      <div class="label">
        Password
      </div>
      <form [formGroup]="pwd">
        <mat-form-field appearance="outline" class="sfull-width">
          <input [(ngModel)]="password" [type]="passwordHide ? 'password' : 'text'" formControlName="password"
                 matInput
                 maxlength="16" minlength="8"
                 placeholder="Enter password"/>
          <mat-icon (click)="passwordHide = !passwordHide" class="eye-icon" matSuffix
                    style="cursor:pointer">{{ passwordHide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
      </form>
    </div>
    <div class="field business-field-section">
      <div class="label">Confirm Password</div>
      <form [formGroup]="cnfirmPwd">
        <mat-form-field appearance="outline" class="sfull-width">
          <input [(ngModel)]="confirmPassword" [type]="cnfirmPasswordHide ? 'password' : 'text'" formControlName="confirmPassword"
                 matInput
                 placeholder="Confirm password"
          />
          <mat-icon (click)="cnfirmPasswordHide = !cnfirmPasswordHide" class="eye-icon" matSuffix
                    style="cursor:pointer">{{ cnfirmPasswordHide ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>
      </form>
    </div>
    <div *ngIf="confirmPasswordBoolean" class="password_validation">
      * Passsword and Confirm Password didn't match.
    </div>
    <div class="submit_btn">
      <button (click)="submit()">Submit</button>
    </div>
  </div>
</section>
